module.exports = __webpack_public_path__ + "img/logo_google_translate.6c294068.png";